function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoAndroidAosp(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    fill: "#0A1633",
    fillRule: "evenodd",
    d: "M18.37 7.05c.114.08.157.233.113.366l-.03.064-1.204 2.007a9.994 9.994 0 014.747 8.233L22 18H2l.004-.28A9.994 9.994 0 016.75 9.487L5.546 7.48a.327.327 0 01.084-.43.27.27 0 01.379.067l.016.024 1.232 2.053A9.956 9.956 0 0112 8c1.716 0 3.332.432 4.743 1.194l1.232-2.053.016-.024a.27.27 0 01.38-.067zM8 12a1 1 0 100 2 1 1 0 000-2zm9 0a1 1 0 100 2 1 1 0 000-2z"
  }));
}

SvgLogoAndroidAosp.clsName = 'icon-uc-social__logo-android_aosp';
SvgLogoAndroidAosp.remarkName = 'unknown';
export default SvgLogoAndroidAosp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoAndroidAosp.js
// module id = 2229
// module chunks = 17 18